import React from 'react';
import { motion } from 'framer-motion';
interface BoundaryCardProps {
  title: string;
  description: string;
  color: 'magenta' | 'cyan' | 'lime' | 'orange';
}
export function BoundaryCard({
  title,
  description,
  color
}: BoundaryCardProps) {
  const colors = {
    magenta: 'text-brand-magenta',
    cyan: 'text-brand-cyan',
    lime: 'text-brand-lime',
    orange: 'text-brand-orange'
  };
  return <motion.div whileHover={{
    y: -5
  }} className="border-2 border-brand-black p-8 bg-white h-full flex flex-col" data-id="element-65">
      <h3 className={`text-xl font-black uppercase mb-4 ${colors[color]}`} data-id="element-66">
        {title}
      </h3>
      <p className="text-gray-700 leading-relaxed" data-id="element-67">{description}</p>
    </motion.div>;
}